/**
 * Created by jonahkim on 4/13/16.
 */

(function () {
    "use strict";

    // @ngInject
    function WSAPIServiceCtor($http, $q, $window, $httpParamSerializerJQLike,
                              Constants, Gon, RepositoryService, MalkutDashboardManager) {
        this.$http = $http;
        this.MalkutDashboardManager = MalkutDashboardManager;
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
        this.RepositoryService = RepositoryService;
        this.$q = $q;
        this.$window = $window;
        this.Gon = Gon;

        this.Constants = Constants;

        this.authObj;
        this.authObjLastRetrieved;
    }

    Services.WSAPIService = Class(function () {

        return {

            constructor: WSAPIServiceCtor,

            _auth: function _auth(method, url, data, headers) {
                var defer = this.$q.defer();

                this.MalkutDashboardManager.getWsApiToken().then(

                    function success(resp){
                        this.authObj = resp.data;
                        this.authObjLastRetrieved = new Date();
                        defer.resolve({method: method, url: url, data: data, headers: headers, authObj: this.authObj})
                    }.bind(this),

                    function error(resp){
                        console.log('Can not get ws auth token...');
                        defer.reject(resp);
                    }.bind(this)

                );

                return defer.promise;
            },

            _isAuthTokenExpired: function _isAuthTokenExpired(){
                if (!this.authObj || !this.authObjLastRetrieved) return true;

                var expires_in = this.authObj.expires_in;
                var now = new Date();
                var expiry = new Date();
                expiry.setSeconds(expiry.getSeconds() + expires_in);
                return now >= expiry;
            },

            _performRequest: function _performRequest(method, url, data, headers) {

                var reqHeaders = {};

                if (headers) {
                    angular.extend(reqHeaders, headers);
                }

                var req;
                if (method === 'GET' || method === 'DELETE') {

                    // Add cache buster to all AJAX GET requests because some fucked-up browsers (Safari) cache them (????)
                    // http://stackoverflow.com/questions/9948545/how-to-disable-ajax-caching-in-safari-browser
                    //
                    // Because of the angular templates cache we cannot use an HTTP Interceptor
                    if (method === 'GET') {
                        if (!angular.isObject(data)) {
                            data = {};
                        }
                        data['nocache'] = +(new Date());
                    }

                    req = {
                        method: method,
                        url: url,
                        headers: reqHeaders,
                        params: data
                    };
                } else {
                    req = {
                        method: method,
                        url: url,
                        headers: reqHeaders,
                        data: data
                    };
                }

                var defer = this.$q.defer();

                this.$http(req)
                    .success(function (data, status, headers, config, statusText) {
                        if (data.status === 1){

                            defer.resolve({
                                data: data.content,
                                status: status,
                                wsStatus: data.status,
                                headers: headers,
                                config: config,
                                statusText: statusText
                            });

                        } else {

                            var resp = {
                                data: data.content,
                                status: status,
                                wsStatus: data.status,
                                headers: headers,
                                config: config,
                                statusText: statusText,
                                stopEvents: false
                            };

                            defer.reject(resp);
                        }
                    }.bind(this))
                    .error(function (data, status, headers, config, statusText) {

                        var resp = {
                            data: data,
                            status: status,
                            wsStatus: null,
                            headers: headers,
                            config: config,
                            statusText: statusText,
                            stopEvents: false
                        };

                        defer.reject(resp);

                    }.bind(this));

                return defer.promise;

            },

            _checkAuthAndPerformRequest: function _checkAuthAndPerformRequest(method, url, data, headers){
                var defer = this.$q.defer();
                if (!this.authObj || this._isAuthTokenExpired()){
                    this._auth(method, url, data, headers).then(

                        function success(authSuccess){
                            authSuccess.headers = {
                                Authorization: "Bearer " + authSuccess.authObj.access_token
                            };

                            this._performRequest(authSuccess.method, authSuccess.url, authSuccess.data, authSuccess.headers).then(
                                defer.resolve,
                                defer.reject
                            );

                        }.bind(this),

                        function error(){

                            return this._performRequest(method, url, data, headers).then(
                                defer.resolve,
                                defer.reject
                            );

                        }.bind(this)
                    );
                } else {
                    headers = {
                        Authorization: "Bearer " + this.authObj.access_token
                    };
                    return this._performRequest(method, url, data, headers);
                }
                return defer.promise;
            },

            fetch: function fetch(url, data, headers) {
                return this._checkAuthAndPerformRequest('GET', url, data, headers);
            },

            create: function create(url, data, headers) {
                return this._checkAuthAndPerformRequest('POST', url, data, headers);
            },

            update: function update(url, data, headers) {
                return this._checkAuthAndPerformRequest('PUT', url, data, headers);
            },

            destroy: function destroy(url, data, headers) {
                return this._checkAuthAndPerformRequest('DELETE', url, data, headers);
            }
        };
    });

})();